module.exports = {"140106001":"柳巷街道","140106002":"文庙街道","140106003":"庙前街道","140106004":"迎泽街道","140106005":"桥东街道","140106006":"老军营街道","140106100":"郝庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140106.json
// module id = 347
// module chunks = 0